__turbopack_context__.v({
  "rawNull__tiSaY": "SZICTG_rawNull__tiSaY",
  "section": "SZICTG_section",
  "sectionHeading": "SZICTG_sectionHeading",
});
